/* eslint-disable react/jsx-boolean-value */
import { Box, Tab, Tabs, useMediaQuery } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { a11yProps, getMonthName } from '../../../../utils/utils';
import { useSelector } from 'react-redux';
import moment from 'moment';
import {
  getKpiGestionesByProfessional,
  getKpiGestionesBySpecialty,
  formatGestionName,
  getTopGestionesStatusEnAgenda,
  getTopGestionesStatusSinAgenda,
  getTopGestionesKpi,
  getKpiByMonth,
  formatFunnelData,
  getLocalDataKpiStorageAnual,
} from '../../helpers';
import { isEmpty, isEqual } from 'lodash';
import Chart from 'react-apexcharts';
import ChartTooltip from './ChartTooltip';
import { handleErrorSwal } from '../../../../shared/swals';

const useStyles = (small) => {
  return makeStyles((theme) => ({
    chart: {
      minHeight: '570px',
      maxHeight: '600px',
    },
  }));
};

const options = {
  indexAxis: 'x',
  elements: {
    bar: {
      borderWidth: 2,
      borderRadius: 4,
      backgroundColor: 'rgba(54, 162, 235, 0.6)',
    },
  },
  responsive: true,
  plugins: {
    legend: {
      position: 'bottom',
      labels: {
        font: {
          family: 'Arial',
          size: 14,
        },
      },
    },
  },
  animation: {
    duration: 800,
    easing: 'easeInOutQuart',
  },
};

const optionsStackedBar = {
  scales: {
    x: {
      stacked: true,
    },
    y: {
      stacked: true,
    },
  },
  plugins: {
    tooltip: {
      enabled: true,
    },
    legend: {
      position: 'bottom',
      labels: {
        font: {
          family: 'Arial',
          size: 14,
        },
      },
    },
    title: {
      display: true,
      text: 'Interacción Usuarios y Bot',
      font: {
        family: 'Arial',
        size: 16,
      },
    },
  },
  responsive: true,
  animation: {
    duration: 800,
    easing: 'easeInOutQuart',
  },
};

const modelData = {
  labels: [],
  datasets: [
    {
      data: [],
    },
  ],
};
function ChartsHealth() {
  // define styles
  const small = useMediaQuery('(max-width:600px)');
  const classes = useStyles(small)();
  // hooks
  const organization = useSelector((state) => state.app.organization);
  const kpiDate = useSelector((state) => state.app.kpiDate);
  const graphicsDescriptions = useSelector((state) => state.app.graphicsDescriptions);

  // states
  const [data, setData] = useState({});
  const [funnelData, setFunnelData] = useState({ series: [], options: {} });
  const [section, setSection] = useState();
  const [reloadData, setReloadData] = useState(true);

  const [gestionesByMonth, setGestionesByMonth] = useState([]);
  const [gestionesByProfessional, setGestionesByProfessional] = useState([]);
  const [gestionesBySpecialty, setGestionesBySpecialty] = useState([]);
  // const [gestionesByChats, setGestionesByChats] = useState([]); DEPRECAR
  // const [gestionesByUniquesChats, setGestionesByUniquesChats] = useState([]);
  const [gestionesByUniqueUsers, setGestionesByUniqueUsers] = useState([]);
  // const [gestionesByMediaMessages, setGestionesByMediaMessages] = useState([]);
  const [gestionesByAppointments, setGestionesByAppointments] = useState([]);
  const [gestionesByStatusSinAgenda, setGestionesBySinAgenda] = useState([]);
  const [gestionesByStatusEnAgenda, setGestionesByEnAgenda] = useState([]);
  const [gestionesByNoSpecialty, setGestionesByNoSpecialty] = useState([]);

  // methods

  const tabData = React.useMemo(
    () => [
      {
        label: 'Gestiones por especialidad',
        value: 'gestionesBySpecialty',
        data: gestionesBySpecialty,
      },
      {
        label: 'Gestiones por profesional',
        value: 'gestionesByProfessional',
        data: gestionesByProfessional,
      },
      {
        label: 'Turnos por mes',
        value: 'gestionesByAppointments',
        data: gestionesByAppointments,
        chartLegend: 'Turnos',
      },
      // DEPRECAR
      // {
      //   label: 'Chats por mes',
      //   value: 'gestionesByChats',
      //   data: gestionesByChats,
      //   chartLegend: 'Chats',
      // },
      // {
      //   label: 'Chats y usuarios únicos por mes',
      //   value: 'gestionesByUniquesChats',
      //   data: gestionesByUniquesChats,
      //   chartLegend: 'Chats',
      // },
      // {
      //   label: 'Interacciones por mes',
      //   value: 'gestionesByMediaMessages',
      //   data: gestionesByMediaMessages,
      //   chartLegend: 'Messages',
      // },
      {
        label: 'Usuarios únicos por mes',
        value: 'gestionesByUniqueUsers',
        data: gestionesByUniqueUsers,
        chartLegend: 'Usuarios',
      },
      {
        label: 'Gestiones por mes',
        value: 'gestionesByMonth',
        data: gestionesByMonth,
        chartLegend: 'Gestion',
      },
      {
        label: 'Sin agenda por mes',
        value: 'gestionesByStatusSinAgenda',
        data: gestionesByStatusSinAgenda,
        chartLegend: 'Sin Agenda',
      },
      {
        label: 'En agenda por mes',
        value: 'gestionesByStatusEnAgenda',
        data: gestionesByStatusEnAgenda,
        chartLegend: 'En Agenda',
      },
      {
        label: 'Especialidades no atendidas por mes',
        value: 'gestionesByNoSpecialty',
        data: gestionesByNoSpecialty,
        chartLegend: 'Especialidad No Atendida',
      },
    ],
    [
      gestionesBySpecialty,
      gestionesByProfessional,
      gestionesByAppointments,
      // gestionesByChats, // DEPRECAR
      gestionesByMonth,
      gestionesByStatusSinAgenda,
      gestionesByNoSpecialty,
    ],
  );

  // effects
  useEffect(() => {
    const tmpData = { ...modelData };
    const tabObject = tabData.find((tab) => tab.value === section);
    switch (section) {
      case 'gestionesBySpecialty': {
        // gestiones por especialidad
        if (!gestionesBySpecialty || isEmpty(gestionesBySpecialty)) break;
        const _data = [...gestionesBySpecialty];

        tmpData.labels = _data.map((e) => e.ESPECIALIDAD);
        tmpData.datasets = [
          {
            label: 'Turnos',
            data: _data.map((e) => e.TURNOS),
            backgroundColor: 'rgba(54, 162, 235, 0.2)',
            borderColor: 'rgba(54, 162, 235, 1)',
            borderWidth: 1,
          },
          {
            label: 'Cancelaciones',
            data: _data.map((e) => e.CANCELACION),
            backgroundColor: 'rgba(255, 99, 132, 0.2)',
            borderColor: 'rgba(255, 99, 132, 1)',
            borderWidth: 1,
          },
          {
            label: 'En agenda',
            data: _data.map((e) => e['EN AGENDA']),
            backgroundColor: 'rgba(255, 159, 64, 0.2)',
            borderColor: 'rgba(255, 159, 64, 1)',
            borderWidth: 1,
          },
        ];
        break;
      }
      case 'gestionesByProfessional': {
        if (!gestionesByProfessional) break;
        tmpData.labels = gestionesByProfessional.map((e) => e.PROFESSIONAL);
        tmpData.datasets = [
          {
            label: 'Turnos',
            data: gestionesByProfessional.map((e) => e.TURNOS),
            backgroundColor: 'rgba(54, 162, 235, 0.2)',
            borderColor: 'rgba(54, 162, 235, 1)',
            borderWidth: 1,
          },
          {
            label: 'Cancelaciones',
            data: gestionesByProfessional.map((e) => e.CANCELACION),
            backgroundColor: 'rgba(255, 99, 132, 0.2)',
            borderColor: 'rgba(255, 99, 132, 1)',
            borderWidth: 1,
          },
        ];
        break;
      }
      // case 'gestionesByChats':
      case 'gestionesByAppointments': {
        // gestiones por mes
        if (!tabObject.data || isEmpty(tabObject.data)) break;
        const _data = [...tabObject.data];
        const monthsNames = _data.map((e) => getMonthName(e.month - 1));
        tmpData.labels = monthsNames;
        tmpData.datasets = [
          {
            label: tabObject.chartLegend,
            data: _data.map((e) => e.total),
            backgroundColor: 'rgba(54, 162, 235, 0.2)',
            borderColor: 'rgba(54, 162, 235, 1)',
            borderWidth: 1,
          },
        ];
        break;
      }
      case 'gestionesByUniquesChats': {
        // gestiones por mes
        if (!tabObject.data || isEmpty(tabObject.data)) break;
        const _data = [...tabObject.data];
        const monthsNames = _data.map((e) => getMonthName(e.month - 1));
        tmpData.labels = monthsNames;
        tmpData.datasets = [
          {
            type: 'bar',
            label: 'Chats',
            data: _data.map((e) => e.totalChats),
            backgroundColor: 'rgba(54, 162, 235, 0.2)',
            borderColor: 'rgba(54, 162, 235, 1)',
            borderWidth: 1,
          },
          {
            type: 'line',
            label: 'Usuarios únicos',
            data: _data.map((e) =>
              Math.round((e.totalChats * e.repeatedClientsSummaryPercentage[1]) / 100),
            ),
            backgroundColor: 'rgba(255, 99, 132, 0.2)',
            borderColor: 'rgba(255, 99, 132, 1)',
            borderWidth: 2,
          },
        ];
        break;
      }
      case 'gestionesByMediaMessages': {
        if (!tabObject.data || isEmpty(tabObject.data)) break;

        const _data = [...tabObject.data][0];
        const userPercentageKeys = Object.keys(_data.repeatedUserMessagesPercentage);
        const botPercentageKeys = Object.keys(_data.repeatedBotMessagesPercentage);
        const date = kpiDate.isSame(moment(), 'month') ? moment().subtract(1, 'month') : kpiDate;
        const month = date.month();

        tmpData.labels = [...new Set([...userPercentageKeys, ...botPercentageKeys])];
        tmpData.datasets = [
          {
            type: 'bar',
            label: 'Interacción usuario',
            data: tmpData.labels.map((key) =>
              Math.round(
                ((_data.repeatedUserMessagesPercentage[key] || 0) * _data.totalChats) / 100,
              ),
            ),
            backgroundColor: 'rgba(255, 99, 132, 0.2)',
            borderColor: 'rgba(255, 99, 132, 1)',
            borderWidth: 1,
          },
          {
            type: 'bar',
            label: 'Interacción bot',
            data: tmpData.labels.map((key) =>
              Math.round(
                ((_data.repeatedBotMessagesPercentage[key] || 0) * _data.totalChats) / 100,
              ),
            ),
            backgroundColor: 'rgba(54, 162, 235, 0.2)',
            borderColor: 'rgba(54, 162, 235, 1)',
            borderWidth: 1,
          },
        ];

        optionsStackedBar.plugins.title.text = `Media de interacciones de ${getMonthName(
          month,
        )} por chat: ${Math.round(
          _data.botMediaPercentageMessages + _data.userMediaPercentageMessages,
        )}`;
        break;
      }
      case 'gestionesByMonth':
      case 'gestionesByStatusSinAgenda':
      case 'gestionesByNoSpecialty':
      case 'gestionesByStatusEnAgenda': {
        if (!tabObject.data) break;
        if (section === 'gestionesByMonth' || section === 'gestionesByNoSpecialty') {
          const selectedData =
            section === 'gestionesByMonth' ? gestionesByMonth : gestionesByNoSpecialty;
          tmpData.labels = selectedData.map(
            (e) => `${formatGestionName(e.GESTION)} (${e.PERCENTAGE}%)`,
          );
        } else {
          tmpData.labels = tabObject.data.map((e) => formatGestionName(e.GESTION));
        }
        tmpData.datasets = [
          {
            label: tabObject.chartLegend,
            data: tabObject.data.map((e) => e.TOTAL),
            backgroundColor: 'rgba(54, 162, 235, 0.2)',
            borderColor: 'rgba(54, 162, 235, 1)',
            borderWidth: 1,
          },
        ];
        break;
      }
      case 'gestionesByUniqueUsers': {
        // gestiones por mes
        if (!tabObject.data || isEmpty(tabObject.data)) break;
        const _data = tabObject.data[0];
        const formattedData = formatFunnelData(_data);
        const date = kpiDate.isSame(moment(), 'month') ? moment().subtract(1, 'month') : kpiDate;
        const month = date.month();

        const optionsFunnel = {
          chart: {
            type: 'bar',
            height: 450,
            toolbar: {
              show: true, // Oculta la barra de herramientas del gráfico
            },
          },
          colors: [
            '#e65100', // Dark Deep Orange
            '#ff6f00', // Dark Orange
            '#f57f17', // Deep Orange
            '#f9a825', // Medium Orange
            '#fbc02d', // Soft Orange
            '#fdd835', // Deep Yellow Orange
            '#ffeb3b', // Yellow
            '#ffee58', // Deep Yellow
            '#fff176', // Medium Yellow
            '#fff59d', // Soft Yellow
            '#fff9c4', // Lighter Yellow
            '#fffde7', // Light Yellow
          ],
          plotOptions: {
            bar: {
              horizontal: true, // Gráfico de barras horizontal
              barHeight: '80%', // Altura de las barras
              distributed: true, // Distribución uniforme de las barras
              isFunnel: true,
            },
          },
          xaxis: {
            categories: formattedData.map((item) => item.label), // Etiquetas del eje X
          },
          dataLabels: {
            enabled: false, // Habilita las etiquetas de datos
            formatter: function (val, opt) {
              return opt.w.globals.labels[opt.dataPointIndex] + ': ' + Math.round(val); // Formato de las etiquetas de datos
            },
            style: {
              colors: ['#333'], // Color del texto de las etiquetas de datos
            },
            offsetX: 0, // Desplazamiento horizontal de las etiquetas de datos
            dropShadow: {
              enabled: true,
              opacity: 0.2,
            },
          },
          legend: {
            show: true, // Oculta la leyenda
            position: 'right',
          },
          title: {
            text: `${getMonthName(month)}`,
            align: 'center',
            style: {
              fontSize: 16,
              fontFamily: 'Arial',
              fontWeight: 600,
              color: '#263238',
            },
          },
        };
        const series = [
          {
            name: 'Cantidad usuarios',
            data: formattedData.map((item) => item.value),
          },
        ];
        setFunnelData({ series: series, options: optionsFunnel });
        break;
      }
    }
    if (tmpData && !isEqual(tmpData, modelData)) {
      setData(tmpData);
    }
  }, [section, reloadData]);

  useEffect(() => {
    kpiDate._isValid && fetchedData();
  }, [kpiDate]);

  useEffect(() => {
    setSection(tabData[findFirstValidTabIndex()].value);
  }, [tabData]);

  const fetchedData = async () => {
    try {
      const dataKpiStorageAnual = getLocalDataKpiStorageAnual();

      const initialChartDate = kpiDate.format('YYYY-MM');
      const dataChartKey = `${initialChartDate}${organization.id}`;
      const dataChartStorage = dataKpiStorageAnual?.[dataChartKey] || {};
      handleChartsData(dataChartStorage?.data);
      setReloadData(!reloadData);
    } catch (error) {
      console.error('fetchedData', error);
      handleErrorSwal();
    }
  };
  const handleChartsData = (data) => {
    if (!data) {
      console.info('handleChartsData >> No data ');
      return [];
    }
    const {
      kpiAnnualAppointmentsByMonth,
      // kpiChatsByMonth, //DEPRECAR
      gestionesKpiChartsRes,
      // kpiChatsStatisticsByMonth,
      kpiUniquesClientsByMonth,
      noSpecialtyKpiByMonth,
    } = data;

    // const kpiChatsUniques = kpiUniquesClientsByMonth;
    const kpiUniquesUsers = getKpiByMonth(kpiUniquesClientsByMonth, kpiDate.format('YYYY-MM'));
    // const kpiMediaMessages = getKpiByMonth(kpiChatsStatisticsByMonth, kpiDate.format('YYYY-MM'));

    const kpiTopGestionesRes = getTopGestionesKpi(gestionesKpiChartsRes);
    const kpiEnAgendaRes = getTopGestionesStatusEnAgenda(gestionesKpiChartsRes);
    const kpiSinAgendaRes = getTopGestionesStatusSinAgenda(gestionesKpiChartsRes);
    const kpiByProfessionalRes = getKpiGestionesByProfessional(gestionesKpiChartsRes);
    const kpiBySpecialtyRes = getKpiGestionesBySpecialty(gestionesKpiChartsRes);

    setGestionesByUniqueUsers(kpiUniquesUsers); // Obtener de Firestore
    // setGestionesByUniquesChats(kpiChatsUniques); // Obtener de Firestore
    // setGestionesByMediaMessages(kpiMediaMessages); // Obtener de Firestore

    setGestionesByAppointments(checkAndFilterTotals(kpiAnnualAppointmentsByMonth)); // Obtener de Firestore
    // setGestionesByChats(checkAndFilterTotals(kpiChatsByMonth)); // Obtener de Firestore // DEPRECAR
    setGestionesBySinAgenda(kpiSinAgendaRes);
    setGestionesByEnAgenda(kpiEnAgendaRes);
    setGestionesByProfessional(kpiByProfessionalRes);
    setGestionesBySpecialty(kpiBySpecialtyRes);
    setGestionesByMonth(kpiTopGestionesRes);
    setGestionesByNoSpecialty(noSpecialtyKpiByMonth);
  };
  const checkAndFilterTotals = (data) => {
    if (!data) return [];
    const allInvalid = data.every((e) => e.total === 0 || e.total == null);
    return allInvalid ? [] : data;
  };
  const findFirstValidTabIndex = () => {
    for (let i = 0; i < tabData.length; i++) {
      if (tabData[i].data && tabData[i].data.length > 0) {
        return i;
      }
    }
    return 0;
  };

  return (
    <Box style={{ position: 'relative' }}>
      <Tabs
        value={section}
        onChange={(_, newValue) => setSection(newValue)}
        indicatorColor="primary"
        textColor="primary"
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
      >
        {tabData.map(
          (tab) =>
            tab.data?.length > 0 && (
              <Tab label={tab.label} key={tab.value} value={tab.value} {...a11yProps(tab.value)} />
            ),
        )}
      </Tabs>
      {!isEmpty(data) && section !== 'gestionesByUniqueUsers' ? (
        <Box display="flex" justifyContent="center" className={classes.chart} mt={3}>
          <Box width="100%">
            {section === 'gestionesByMediaMessages' ? (
              <>
                <Bar key={`bar-${section}`} data={data} options={optionsStackedBar} redraw={true} />
                <ChartTooltip infoText={graphicsDescriptions?.charts?.[section]} />
              </>
            ) : (
              <>
                <Bar key={`bar-${section}`} data={data} options={options} redraw={true} />
                <ChartTooltip infoText={graphicsDescriptions?.charts?.[section]} />
              </>
            )}
          </Box>
        </Box>
      ) : (
        !isEmpty(funnelData.series) && (
          <Box display="flex" justifyContent="center" className={classes.chart} mt={3}>
            <Box width="100%">
              <Chart
                key={`funnel-${section}`}
                options={funnelData.options}
                series={funnelData.series}
                type="bar"
              />
              <ChartTooltip infoText={graphicsDescriptions?.charts?.[section]} />
            </Box>
          </Box>
        )
      )}
    </Box>
  );
}

export default ChartsHealth;
